export default "__VITE_PUBLIC_ASSET__bded8679__"